import { SigningMethodEnum, VerificationMethod } from '@dss-libs/shared/type/common-types';
import {
  ICreateOrderFormModel,
  INotificationRecipientFormModel,
  IOrderStepFormModel,
  IRecipientFormModel,
  ReminderInterval,
} from '@dss-libs/portal/type/portal-types';

export function createEmptyRecipient(): IRecipientFormModel {
  return {
    name: '',
    email: '',
    phone: { countryCode: 'EG', phoneNumber: '' },
    task: 'signer',
  };
}

export function createOrderStep(): IOrderStepFormModel {
  return { recipients: [createEmptyRecipient()] };
}

export function createEmptyNotificationRecipient(): INotificationRecipientFormModel {
  return { name: '', email: '' };
}

export function createInitialCreateOrderModel(): ICreateOrderFormModel {
  return {
    documents: { count: 0 },
    recipientInformation: { steps: [createOrderStep()] },
    orderSettings: {
      name: '',
      language: 'en',
      expirationPeriod: '30',
      reminderInterval: ReminderInterval.Never,
      signingMethod: SigningMethodEnum.DEFAULT,
      verificationMethod: VerificationMethod.Email,
      requireSignerAuthentication: false,
      notificationRecipients: [],
    },
    orderMessage: { emailSubject: '', emailBody: '' },
  };
}
